import React, { useEffect, useState } from 'react';

import { Container, Card, Form, Button } from 'react-bootstrap';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
    getAuth,
    signInWithEmailAndPassword
} from "firebase/auth";

import { firebaseConfig } from './firebase/firebaseConfig'

function Login() {
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    const auth = getAuth();

    const [email, setEmail] = useState('email');
    const [password, setPassword] = useState('password');

    const loginUser = () => {
        signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                // Signed in 
                const user = userCredential.user;
                console.log('login success');
                console.log(user);
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log('login fail');
                console.log(errorCode);
                console.log(errorMessage);
            });
    }

    return (
        <Container>
            <Card style={{ textAlign: 'left', width: '300px', padding: '20px', margin: '20px' }}>
                <Form>
                    <Form.Group className="mb-3" controlId="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" placeholder="Enter email" onChange={(event) => {
                            setEmail(event.target.value)
                        }} />
                    </Form.Group>
                </Form>
                <Form>
                    <Form.Group className="mb-3" controlId="password">
                        <Form.Label>Possword</Form.Label>
                        <Form.Control type="password" placeholder="Enter password" onChange={(event) => {
                            setPassword(event.target.value)
                        }} />
                    </Form.Group>
                </Form>
                <>
                    <Button variant="primary" onClick={loginUser}>登入</Button>
                </>
            </Card>
        </Container>
    );
}

export default Login;
